import styled from "styled-components";

const ListStyles = styled.div`
  .listProduct {
  
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;
export default ListStyles;
